var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cx from 'classnames';
import { forwardRef } from 'react';
var JustInput = function (props, ref) {
    var prefix = props.prefix, error = props.error, nativeProps = __rest(props, ["prefix", "error"]);
    var className = cx(nativeProps.className, 'c-input', { 'c-input--prepend': !!prefix });
    return (_jsxs("div", { className: "u-position-relative", children: [!!prefix && _jsx("div", { className: "c-prefix u-inline-block", children: prefix }), _jsx("input", __assign({}, nativeProps, { className: className, ref: ref })), !!error && _jsx("div", { className: "c-input-error-message", children: error })] }));
};
export var Input = forwardRef(JustInput);
